import(/* webpackMode: "eager", webpackExports: ["NavAuthArea"] */ "/app/dashboard/app/_components/NavAuthArea.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavLinks"] */ "/app/dashboard/app/_components/NavLinks.tsx");
;
import(/* webpackMode: "eager" */ "/app/dashboard/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
